// +----------------------------------------------------------------------
// | @Des:绘制年度图表
// +----------------------------------------------------------------------

import * as echarts from "echarts";

export function echartsQYPM(that, nowYearAllQYPM) {
  // 确保 DOM 元素存在
  const chartContainer = document.getElementById("echartsQYPM");
  if (!chartContainer) {
    console.error("Element with id 'echartsQYPM' not found.");
    return;
  }

  // 验证输入数据
  if (!nowYearAllQYPM || !Array.isArray(nowYearAllQYPM.date) || !Array.isArray(nowYearAllQYPM.month_list_count)) {
    console.error("Invalid input data for nowYearAllQYPM.");
    return;
  }

  try {
    // 初始化 echarts 实例
    const myChart = echarts.init(chartContainer);

    // 定义配置项
    const option = {
      tooltip: {
        trigger: "axis",
      },
      grid: {
        top: "5%",
        right: "6%",
        bottom: "40",
        left: "15%",
      },
      xAxis: [
        {
          type: "category",
          data: nowYearAllQYPM.date,
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,.1)",
            },
          },
          axisLabel: {
            rotate: 45,
            textStyle: {
              rotation: 45,
              color: "rgba(255,255,255,.7)",
              fontSize: "12",
            },
          },
          splitLine: {
            show: false, // 移除x轴的网格线
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          splitLine: {
            show: false, // 移除y轴的网格线
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "rgba(255,255,255,.6)",
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,.5)",
            },
          }, //左线色
        },
      ],
      series: [
        {
          name: "总立方数",
          type: "bar",
          data: nowYearAllQYPM.month_list_count,
          barWidth: "40%",
          showBackground: true,
          backgroundStyle: {
            color: "rgba(255, 255, 255, 0.1)", // 背景颜色
          },
          itemStyle: {
            normal: {
              barBorderRadius: [0, 0, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#D7F6FF",
                },
                {
                  offset: 1,
                  color: "#0C96FF",
                },
              ]),
            },
          },
          barGap: "0",
        },
      ],
    }; 

    // 使用刚指定的配置项和数据显示图表
    myChart.setOption(option);

    // 添加点击事件监听（放在setOption之后）
    myChart.on("click", { seriesName: "总立方数" }, (params) => {
      that.$QHopen.url('/electronicbillPFZL?year='+that.year, 99)
    });

    // 销毁时移除事件监听（重要！）
    window.addEventListener("beforeunload", () => {
      myChart.off("click");
    });

    // 添加 resize 事件监听器
    let resizeHandler = null;
    if (resizeHandler) {
      window.removeEventListener("resize", resizeHandler);
    }
    resizeHandler = () => myChart.resize();
    window.addEventListener("resize", resizeHandler);
  } catch (error) {
    console.error("Error initializing or setting options for echarts:", error);
  }
}
